(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accessibility-tools"] && !Shopify.designMode) return;
  try {
    (() => {
    const tools = document.getElementById('AccessibilityTools');
    if (!tools) return;
    const root = document.documentElement;
    const size = tools.querySelector('#AccessibilityTextSize');
    const checks = tools.querySelectorAll('[data-access-pref]');
    const key = 'neolith-accessibility-preferences-v1';
    let prefs = { size: '100', contrast: false, links: false, motion: matchMedia('(prefers-reduced-motion: reduce)').matches };
    try { const saved = JSON.parse(localStorage.getItem(key) || '{}'); for (const name of Object.keys(prefs)) { if (typeof saved[name] === typeof prefs[name]) prefs[name] = saved[name]; } } catch {}
    if (!['100', '125', '150', '200'].includes(prefs.size)) prefs.size = '100';
    const apply = () => {
      root.dataset.accessSize = prefs.size;
      size.value = prefs.size;
      for (const input of checks) { const name = input.dataset.accessPref; input.checked = prefs[name]; root.toggleAttribute('data-access-' + name, prefs[name]); }
      if (prefs.motion) {
        document.querySelectorAll('video, audio').forEach(media => media.pause());
        document.querySelectorAll('slideshow-component').forEach(slideshow => slideshow.pause?.());
      }
      try { localStorage.setItem(key, JSON.stringify(prefs)); } catch {}
    };
    size.addEventListener('change', () => { prefs.size = size.value; apply(); });
    for (const input of checks) input.addEventListener('change', () => { prefs[input.dataset.accessPref] = input.checked; apply(); });
    tools.querySelector('[data-access-reset]').addEventListener('click', () => { prefs = { size: '100', contrast: false, links: false, motion: false }; apply(); });
    const close = () => { tools.open = false; tools.querySelector('summary').focus(); };
    tools.querySelector('[data-access-close]').addEventListener('click', close);
    tools.addEventListener('keydown', event => { if (event.key === 'Escape' && tools.open) { event.stopPropagation(); close(); } });
    tools.querySelector('.access-tools__controls').hidden = false;
    tools.querySelector('[data-access-close]').hidden = false;
    apply();
  })();
  } catch(e) { console.error(e); }
})();

})();
